import { render, staticRenderFns } from "./AppointmentSlots.vue?vue&type=template&id=9a27fa76"
import script from "./AppointmentSlots.vue?vue&type=script&lang=ts"
export * from "./AppointmentSlots.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentSlots.vue?vue&type=style&index=0&id=9a27fa76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports